<template>
    <div class="operate-process fx-center">
        <div v-for="item in names"
            :key="item.id"
            class="operate-process__item"
            :class="getActiveId === item.id ? 'active' : ''">
            <div class="operate-process__item-before" />
            {{ item.name }}
            <div class="operate-process__item-after" />
        </div>
    </div>
</template>

<script>
import { createComponent } from '@vue/composition-api'

export default createComponent({
    props: {
        names: {
            type: Array,
            required: true,
            validator(val) {
                return val.every(value => typeof value.name === 'string' && typeof value.id === 'number')
            }
        },
        activeId: Number
    },

    computed: {
        getActiveId() {
            return this.activeId != null ? this.activeId : this.names[0].id
        }
    }
})
</script>

<style lang="scss" scoped>
.operate-process {
    &__item {
        position: relative;
        width: 114px;
        height: 30px;
        line-height: 30px;
        margin-left: -6px;
        font-size: 12px;
        font-weight: bold;
        color: #999;
        text-align: center;
        box-sizing: content-box;

        &::before,
        &::after {
            content: '';
            position: absolute;
            left: 0;
            width: 104px;
            height: 1px;
            background-color: #ddd;
        }

        &::after {
            top: auto;
            bottom: 0;
        }

        &:first-child {
            margin-left: 0;
        }

        &.active {
            color: #009688;

            &::before,
            &::after {
                background-color: #009688;
            }

            .operate-process__item-before,
            .operate-process__item-after {
                &::before,
                &::after {
                    background-color: #009688;
                }
            }
        }

        &-before,
        &-after {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;

            &::before,
            &::after {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 1px;
                height: 18px;
                background-color: #ddd;
            }

            &::before {
                transform-origin: top;
                transform: rotateZ(-30deg);
            }

            &::after {
                top: auto;
                bottom: 0;
                transform-origin: bottom;
                transform: rotateZ(30deg);
            }
        }

        &-after {
            left: auto;
            right: 11px;
        }
    }
}
</style>
